import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import './index.css';
import './app.css';

const root = createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
